import { shallowEqual, useSelector } from "react-redux";

// Selects only the given `state.user` fields. Selecting the whole `state.user`
// re-renders the component on every loggedUsers/loggedStatus update, which
// the server pushes whenever any operator changes page.
export default function useUserFields(...fields) {
  return useSelector((state) => {
    const selected = {};
    for (const field of fields) selected[field] = state.user[field];
    return selected;
  }, shallowEqual);
}
